<script lang="ts">
    import type { ValueHumanDescription } from '../components/telematics/components/Colorizer/types';
    import { smartRounding } from '../components/telematics/tools/smartRounding';
    import { debug } from '../../stores/store';

    export let meters: number | null = null;
    export let compare: number | null = null;
    export let estimation: boolean = false;
    export let noColors: boolean = false;
    export let flexDirection: 'row' | 'column' = 'row';
    export let bold: boolean = true;

    let rounded: ValueHumanDescription | null = null;
    let diff: ValueHumanDescription | null = null;
    let diffstr: string = '';
    let prefix: string = '';

    $: {
        if ($debug) {
            meters = 123456789;
        }
    }

    $: {
        if (meters === null) {
            rounded = null;
        } else {
            rounded = new smartRounding().getRoundedValues(meters, 'm', { convert_nicer: true });
        }
        if (meters !== null && compare !== null && meters != compare) {
            diff = new smartRounding().getRoundedValues(meters - compare, 'm', {
                convert_nicer: true,
            });
            diffstr =
                ((diff.original_value || 0) < 0 ? '' : '+') +
                [diff.rounded_value, diff.rounded_title].join(' ');
            // diff.rounded_unit;
        } else {
            diff = null;
            diffstr = '';
        }
    }

    $: {
        estimation = estimation;
        // prefix = estimation ? `.. ` : ``;
        prefix = estimation ? `` : ``;
    }

    // prefix = estimation ? `.. ` : ``;
    prefix = estimation ? `` : ``;
</script>

<div
    data-meters={JSON.stringify(meters)}
    data-info="INFO"
    style="display: flex; align-items: baseline; justify-content: flex-end; column-gap: 3px;"
    class:estimation
    class:noColors
>
    {#if rounded === null}
        <div class:bold class="dont-break">---</div>
    {:else}
        <div style="display: flex; flex-direction: {flexDirection}; column-gap: 5px;">
            <div
                style="display: flex; flex-direction: row; column-gap: 3px; align-items: baseline; justify-content: flex-end;
{flexDirection === 'column' ? 'margin-bottom: 0;' : ''}"
                title={meters ? (meters/1000).toFixed(3) + ' km' : ''}
            >
                <div class:bold class="dont-break">
                    {prefix}{[rounded.rounded_value, rounded.rounded_title].join('')}
                </div>
                <div class="lite dont-break" style="padding: 1px 0;">{rounded.rounded_unit}</div>
            </div>
            {#if compare !== null && flexDirection === 'row'}
                <div
                    class="difference"
                    class:empty={!diff}
                    class:improvement={diff && diff.original_value < 0}
                >
                    ({diffstr}
                    {diff?.rounded_unit ?? ''})
                </div>
            {/if}
            {#if compare !== null && flexDirection === 'column'}
                <div
                    class="difference difference-column"
                    style="margin-top: -2px; display:flex; flex-direction: row; column-gap: 3px; align-items: center; justify-content: flex-end;"
                    class:empty={!diff}
                    class:improvement={diff && diff.original_value < 0}
                    class:noColors
                >
                    <div>
                        {diffstr}
                    </div>
                    <div class="lite" style="padding: 1px 0;">
                        {diff?.rounded_unit ?? ''}
                    </div>
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .bold {
        font-weight: 500;
    }
    .lite {
        font-weight: 300;
        opacity: 0.6;
        font-size: 0.7rem;
    }
    .empty {
        display: none;
    }
    .difference {
        color: var(--automapa-red);
    }
    .difference.improvement {
        color: var(--automapa-green-dark);
    }
    .noColors .difference,
    .noColors .difference.improvement {
        color: currentColor;
    }

    .difference-column {
        font-size: 12px;
        color: var(--planning-page-accent-color);
    }
    .difference-column.improvement {
        color: var(--planning-page-accent-color);
    }
    .difference-column.noColors {
        opacity: 0.5;
        /*color: red;*/
    }

    .estimation {
        /*font-style: italic;*/
        font-weight: 400;
        opacity: 0.5;
    }
</style>
